export default __webpack_public_path__ + "static/media/how-it-works-3.2fd55be8.png";